import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterObject } from '../filter-object';

@Component({
  selector: 'filter-dropdown',
  template: `
    <i
      *ngIf="!filterObject.active"
      class="fa fa-search toggleInput pointer"
      (click)="toggleFilter($event)"
    ></i>

    <span *ngIf="filterObject.active">
      <mat-form-field appearance="outline">
        <mat-select
          [(ngModel)]="filterObject.value"
          (selectionChange)="onDropdownChange()"
          placeholder="{{ placeholder }}"
        >
          <mat-option [value]="null">- leeg -</mat-option>
          <mat-option *ngFor="let option of keyValueMap" [value]="option.key">
            {{ option.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
  `,
})
export class FilterDropdownComponent implements OnInit {
  @Input() public keyValueMap: { key: string; value: string }[];
  @Input() public filterObject: FilterObject;
  @Input() public placeholder: string;

  @Output() public toggleFilterEmitter: EventEmitter<string> =
    new EventEmitter<string>();
  @Output() public filterValueChanged: EventEmitter<any> =
    new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  public onDropdownChange(): void {
    if (this.filterObject.value === null) {
      this.filterObject.value = '';
      this.toggleFilterEmitter.emit(this.filterObject.key);
      this.filterValueChanged.emit('');
    } else {
      this.filterValueChanged.emit(this.filterObject);
    }
  }

  public toggleFilter(event: Event): void {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.filterObject.value = '';
    this.toggleFilterEmitter.emit(this.filterObject.key);
  }
}
